const Table = ({ columns, data }) => {

    return (
        <table className="w-full rounded-[20px] shadow-[4px_4px_30px_0_rgba(105,133,194,0.10)] overflow-hidden">
            <thead className="bg-[#F9F9F9]">
                <tr>
                    {columns.map((column, index) => (
                        <th key={index} className="text-left text-[#364153] text-sm font-bold p-5 border-b border-[#DBDBDB]">
                            {typeof column === 'string' ? column : column.label}
                        </th>
                    ))}
                </tr>
            </thead>
            <tbody className="bg-white hide-scrollbar">
                {data.map((row, index) => (
                    <tr key={index} className="border-b border-[#E7E7E7] hover:bg-[#F9F9F9] transition-all duration-300">
                        {columns.map((column, colIndex) => {
                            let cellContent;

                            if (typeof column === 'string') {
                                // Simple string column key
                                cellContent = row[column];
                            } else {
                                // Object column with optional render function
                                const cellValue = row[column.key];

                                if (column.render) {
                                    // Use custom render function if provided
                                    cellContent = column.render(cellValue, row, index);
                                } else {
                                    // Default: render the data value
                                    cellContent = cellValue;
                                }
                            }

                            return (
                                <td key={colIndex} className="text-left p-5">
                                    {cellContent}
                                </td>
                            );
                        })}
                    </tr>
                ))}
            </tbody>
        </table>
    );

}

export default Table;